import React from "react";
import { useMsal } from "@azure/msal-react";
import "./Header.css";

function Header({ clienti = [], selectedClienteId, onSelectCliente }) {
  const { accounts, instance } = useMsal();
  const isAuthenticated = accounts.length > 0;
  const selectedCliente = clienti.find((cliente) => cliente.id === selectedClienteId);
  const userIdentity = accounts[0]
    ? `${accounts[0].name || ""} (${accounts[0].username || ""})`
    : "";

  const handleLogout = () => {
    instance.logout();
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo-section">
          <img src="/01_Socialit_marchio_RGB_colorato%20%2B%20bianco.png" alt="Socialit logo" className="header-logo" />
          <h1 className="title">Customer Service Portal</h1>
        </div>
        {isAuthenticated && (
          <div className="user-section">
            <div className="user-info">
              <span className="user-name">{userIdentity}</span>
              {clienti.length > 1 ? (
                <select
                  className="client-select"
                  value={selectedClienteId ?? ""}
                  onChange={(event) => onSelectCliente(event.target.value)}
                >
                  {clienti.map((cliente) => (
                    <option key={cliente.id} value={cliente.id}>
                      {cliente.nome}
                    </option>
                  ))}
                </select>
              ) : (
                selectedCliente && <span className="client-name">{selectedCliente.nome}</span>
              )}
            </div>
            <button onClick={handleLogout} className="btn-logout">
              <span className="btn-logout-icon" aria-hidden="true">↪</span>
              Esci
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
